import { useTranslation } from '@thoughtspot/i18n';
import { isValidNumericString, safeNumberFormat, } from '@thoughtspot/number-format-util';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import _ from 'lodash';
import React from 'react';
import { getStyles, OPERATOR_TO_TEXT, showDecimalValue, } from '../../core/conditional-formatting-utils';
import styles from '../../styles/conditional-metric-item-preview.module.scss';
import { Operators } from '../../types';
export const ConditionalMetricSolidImage = ({ metric, isHideFormatPreviewText, shouldShowBackgroundColor, }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: styles.image, style: getStyles(metric, shouldShowBackgroundColor) }, !isHideFormatPreviewText && t('Aa')));
};
export const getPresentationValue = (value) => {
    if (_.isNil(value)) {
        return undefined;
    }
    if (_.isNumber(value)) {
        return safeNumberFormat({ useGrouping: true }, value);
    }
    if (_.isBoolean(value)) {
        return value;
    }
    if (isValidNumericString(value) && showDecimalValue(value)) {
        return safeNumberFormat({ useGrouping: true }, parseFloat(value));
    }
    return value;
};
export const ConditionalMetricCondition = ({ operator, values, hasDataSourceAccessPermission, isMetricInfo, rhsColumnName, }) => {
    const { t } = useTranslation();
    const firstOperand = values[0] === ''
        ? rhsColumnName || t('EMPTY_VALUE_PLACEHOLDER_LABEL')
        : getPresentationValue(values[0]);
    const secondOperand = getPresentationValue(values[1]);
    const operatorString = operator === Operators.Is
        ? ''
        : t(`Conditional_operator.${OPERATOR_TO_TEXT[operator]}`);
    const presentedMetricCondition = t(`${operatorString} ${firstOperand ? `${firstOperand}` : ''} ${secondOperand ? `and ${secondOperand}` : ''}`);
    let tooltipContent = hasDataSourceAccessPermission
        ? presentedMetricCondition
        : t('permission.requestEditAccess');
    tooltipContent = isMetricInfo ? '' : tooltipContent;
    return (React.createElement(Horizontal, { "data-tooltip-content": tooltipContent, className: styles.metricConditionWrapper },
        React.createElement("div", { className: styles.metricCondition }, presentedMetricCondition)));
};
//# sourceMappingURL=conditional-metric-item-preview.js.map